import styled from 'styled-components'
import { boxShadow, primary, bgPrimaryLight, primaryGradient, widthFull, widthResize, heightHeader, widthWithPadding, widthResizeWithPadding } from '../Resources/Theme'

const Nav = styled.div`
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: 100%;
  background: #faf8f5;
  border-right: 1px solid #ebe7e0;
  overflow: hidden;
  transition: .5s;
  z-index: 99;

  &:hover {
    overflow: auto;
    overflow-x: hidden;
  }

  &::-webkit-scrollbar-track {
    background-color: #faf8f5;
    position: fixed;
    margin-top: ${heightHeader};
  }

  &::-webkit-scrollbar {
    width: .3rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d4cdbf;
    border-radius: 6px;
  }

  @media (max-width: 992px) {
    width: ${widthFull};
    margin-left: -${props => props.mobile ? '0' : '280'}px;
    overflow: auto;
    overflow-x: hidden;
  }
`

Nav.Bg = styled.div`
  display: none;
  z-index: 99;

  @media (max-width: 992px) {
    display: ${props => props.mobile ? 'block' : 'none'};
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(44, 42, 32, 0.5);
    backdrop-filter: blur(4px);
  }
`
Nav.Title = styled.li`
  height: 29px;
  width:  ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : widthWithPadding};
  font-weight: lighter;
  padding-top: 0px;
  padding-bottom: 10px;
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : ''};
  span {
    display: ${props => props.resize && !props.resizeOpen ? 'none' : 'block'};
    align-self: center;
  }
  i {
    display: ${props => props.resize && !props.resizeOpen ? 'block' : 'none'};
    align-self: center;
  }

  @media (max-width: 992px) {
    display: block;
    justify-content: flex-start;
    width: ${widthWithPadding};

    span {
      display: block;
    }
    i {
      display: none;
    }
  }
`
Nav.Swipe = styled.div`
  display: none;
  position: fixed;
  width: 30px;
  height: 100%;
  z-index: 1;
  
  @media (max-width: 992px) {
    display: block;
  }
`

/* Start Brand */
Nav.Brand = styled.div`
  color: #3a2f1e;
  position: fixed;
  width: ${props => props.resize && !props.resizeOpen ? widthResize : widthFull};
  height: ${heightHeader};
  display: flex;
  justify-content: space-between;
  background: #faf8f5;
  padding: 0 ${props => props.resize && !props.resizeOpen ? '8' : '20'}px;
  transition: .5s;
  border-bottom: 1px solid #ebe7e0;
  z-index: 1;

  @media (max-width: 992px) {
    padding: 0 20px;
    justify-content: center;
    width: ${widthFull};
  }
`
Nav.Brand.Link = styled.a`
  align-self: center;
`
Nav.Brand.Logo = styled.img`
  // width: ${props => props.resize && !props.resizeOpen ? '54px' : '148px'};
  align-self: center;
  transition: .5s;
  max-height: calc(${heightHeader} - 24px);

  @media (max-width: 992px) {
    display: none;
  }
`
Nav.Brand.IconSize = styled.div`
  align-self: center;
  padding: 5px;
  cursor: pointer;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'flex'};
  justify-content: center;
  font-size: 1.2rem;
  color: #a09585;

  @media (max-width: 992px) {
    display: none;
  }
`
Nav.Brand.IconMobile = styled.div`
  align-self: center;
  display: none;
  padding: 5px;
  font-size: 1.2rem;
  color: #a09585;

  @media (max-width: 992px) {
    display: flex;
  }
`
/* End Brand */

/* Start One Level */
Nav.OneLevel = styled.ul`
  padding: 0 16px 32px;
  padding-top: 96px;
  list-style: none;
`
Nav.OneLevel.Item = styled.li`
  padding-bottom: 6px;
  width: ${props => props.resize && !props.resizeOpen ? widthResizeWithPadding : widthWithPadding};

  @media (max-width: 992px) {
    width: ${widthWithPadding};
  }
`
Nav.OneLevel.TitleContent = styled.div`
  display: flex;
  justify-content: ${props => props.resize && !props.resizeOpen ? 'center' : 'space-between'};;
  background: ${props => props.active ? '#f0ece4' : 'transparent'};
  border: 1px solid ${props => props.active ? '#e0d9cc' : 'transparent'};
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  margin-bottom: 2px;
  min-height: 48px;
  color: ${props => props.active ? '#3a2f1e' : '#8c8377'};
  font-weight: ${props => props.active ? '600' : '500'};
  transition: background-color .2s ease, color .2s ease;

  &:hover {
    background: #f3efea;
    color: #3a2f1e;
  }

  @media (max-width: 992px) {
    justify-content: space-between;
  }
`
Nav.OneLevel.Title = styled.div`
  align-self: center;
  display: flex;
`
Nav.OneLevel.IconArrow = styled.span`
  align-self: center;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  transform: ${props => props.active ? 'rotate(225deg)' : 'rotate(135deg)'};
  transition: .3s;
  content: '';
  width: 7px;
  height: 7px;
  border-width: 2px 0 0 2px;
  border-style: solid;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
Nav.OneLevel.Icon = styled.span`
  margin-right: ${props => props.resize && !props.resizeOpen ? '' : '0.85rem'};
  display: flex;
  width: 22px;
  align-self: center;
  opacity: 0.7;

  @media (max-width: 992px) {
    margin-right: 0.85rem;
  }
`
Nav.OneLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  align-self: center;
  font-size: 0.9rem;

  @media (max-width: 992px) {
    display: inline-block;
  }
`
/* End One Level */

/* Start Second Level */
Nav.SecondLevel = styled.ul`
  list-style: none;
  padding-left: 8px;
  display: ${props => props.resize && !props.resizeOpen ? 'none' : (props.active ? 'block' : 'none')};
  @media (max-width: 992px) {
    display: ${props => props.active ? 'block' : 'none'};
  }
`
Nav.SecondLevel.Item = styled.li`
  display: flex;
  justify-content: space-between;
  background: ${props => props.active ? '#3a2f1e' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#8c8377'};
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
  margin-bottom: 4px;
  transition: background-color .2s ease, color .2s ease;

  &:hover {
    background: ${props => props.active ? '#3a2f1e' : '#f3efea'};
    color: ${props => props.active ? '#fff' : '#3a2f1e'};
  }
`
Nav.SecondLevel.Title = styled.div`
  align-self: center;
  display: flex;
  height: 20px;
`
Nav.SecondLevel.Icon = styled.span`
  margin-right: 0.85rem;
  align-self: center;
  display: flex;
  width: 6px;
  height: 6px;
  border-radius: 10px;
  background: currentColor;
  opacity: 0.5;
`
Nav.SecondLevel.Description = styled.span`
  display: ${props => props.resize && !props.resizeOpen ? 'none' : 'inline-block'};
  font-weight: 500;
  font-size: 0.86rem;
  width: ${widthWithPadding};
  align-self: center;

  @media (max-width: 992px) {
    display: inline-block !important;
  }
`
/* End Second Level */

export default Nav
